import React, { Component } from "react";
import logo from "./logo.gif";

export default class Paypal extends Component {
  componentDidMount() {
    this.image.addEventListener("click", e => {
      e.preventDefault();
      this.formulaire.submit();
    });
  }
  render() {
    const styles = {
      image: {
        position: "fixed",
        bottom: "0px",
        right: "0px",
        cursor: "pointer"
      },
      formulaire: {
        display: "none"
      }
    };
    return (
      <div>
        <form
          action="https://www.paypal.com/cgi-bin/webscr"
          method="post"
          target="_top"
          ref={ref => {
            this.formulaire = ref;
          }}
          style={styles.formulaire}
        >
          <input type="hidden" name="cmd" value="_s-xclick" />
          <input type="hidden" name="hosted_button_id" value="Q2XYVFP4EEX2J" />
          <input alt="faire un don" type="image" name="submit" />
        </form>
        <img
          src={logo}
          alt="paypal"
          style={styles.image}
          ref={ref => {
            this.image = ref;
          }}
          title="Si vous pensez que cet outil le mérite... Merci !"
        />
      </div>
    );
  }
}
